import { graphql } from "@/graphql/generated/gql";
import { UpdateMunicipalPropertyMutation, UpdateMunicipalPropertyMutationVariables } from "@/graphql/generated/graphql";
import { TypedDocumentNode } from "@graphql-typed-document-node/core";

export const UPDATE_MUNICIPAL_PROPERTY_MUTATION_DOCUMENT: TypedDocumentNode<
  UpdateMunicipalPropertyMutation,
  UpdateMunicipalPropertyMutationVariables
> = graphql(/* GraphQL */ `
  mutation UpdateMunicipalProperty($input: UpdateMunicipalPropertyInput!) {
    updateMunicipalProperty(input: $input) { id archivedAt }
  }
`);
